// Actions
export const SCHEDULES__GET_SCHEDULE = 'SCHEDULES__GET_SCHEDULE';
export const SCHEDULES__REJECT_QUOTE = 'SCHEDULES__REJECT_QUOTE';
export const SCHEDULES__APPROVE_QUOTE = 'SCHEDULES__APPROVE_QUOTE';
export const SCHEDULES__SUBMIT_QUOTE_ISSUE = 'SCHEDULES__SUBMIT_QUOTE_ISSUE';
export const SCHEDULES__RESUME_EARLY = 'SCHEDULES__RESUME_EARLY';
// Getters
export const SCHEDULES__GROUPED_BY_PROPERTY = 'SCHEDULES__GROUPED_BY_PROPERTY';
export const SCHEDULES__ACTIVE_SERVICES = 'SCHEDULES__ACTIVE_SERVICES';
// Mutations
export const SCHEDULES__RESET = 'SCHEDULES__RESET';
export const SCHEDULES__MUTATE_SCHEDULES = 'SCHEDULES__MUTATE_SCHEDULES';
export const SCHEDULES__MUTATE_SCHEDULE = 'SCHEDULES__MUTATE_SCHEDULE';
export const SCHEDULES__MUTATE_LOADING_STATUS = 'SCHEDULES__MUTATE_LOADING_STATUS';
